import React from 'react';
import styles from './styles.scss';

const DropdownGroup = React.memo(
  ({
    className,
    name,
    label,
    optionValues,
    onChange,
    onBlur,
    initialValue,
  }) => {
    const hasOptionValues = optionValues && optionValues.size > 0;

    return (
      <div
        className={`${styles.dropdownGroup} ${styles.inputWrapper} ${
          className ? ` ${className}` : ''
        }`}
      >
        <label htmlFor={name} className={styles.formLabel}>
          <b>{label}</b>
        </label>
        {hasOptionValues ? (
          <select
            className={styles.select}
            name={name}
            onChange={onChange}
            onBlur={onBlur}
            defaultValue={initialValue}
          >
            {optionValues?.map((optionValue) => {
              const id = optionValue.get('id');

              return (
                <option value={id} key={id}>
                  {optionValue.get('name')}
                </option>
              );
            })}
          </select>
        ) : (
          <div className={styles.select} />
        )}
      </div>
    );
  }
);

DropdownGroup.displayName = 'DropdownGroup';

export default DropdownGroup;
